import type { Formula, FormulaState } from "@/types";
import type { MutationTree } from "vuex";

export const LOAD_FORMULA_VARIABLES = "LOAD_FORMULA_VARIABLES";
export const LOAD_FORMULA_VARIABLES_SUCCESS = "LOAD_FORMULA_VARIABLES_SUCCESS";
export const LOAD_FORMULA_VARIABLES_FAILURE = "LOAD_FORMULA_VARIABLES_FAILURE";

export const CHECK_FORMULA = "CHECK_FORMULA";
export const CHECK_FORMULA_SUCCESS = "CHECK_FORMULA_SUCCESS";
export const CHECK_FORMULA_FAILURE = "CHECK_FORMULA_FAILURE";

export const SAVE_FORMULA = "SAVE_FORMULA";
export const SAVE_FORMULA_SUCCESS = "SAVE_FORMULA_SUCCESS";
export const SAVE_FORMULA_FAILURE = "SAVE_FORMULA_FAILURE";

export const LOAD_FORMULA = "LOAD_FORMULA";
export const LOAD_FORMULA_SUCCESS = "LOAD_FORMULA_SUCCESS";
export const LOAD_FORMULA_FAILURE = "LOAD_FORMULA_FAILURE";
export const INIT_STORE_FORMULA_FAILURE = "INIT_STORE_FORMULA_FAILURE";

export const RESET_FORMULA = "RESET_FORMULA";
export const RESET_NEW_FORMULA = "RESET_NEW_FORMULA";
export const RESET_TO_EDIT_FORMULA = "RESET_TO_EDIT_FORMULA";

export const mutations: MutationTree<FormulaState> = {
  // LOAD_FORMULA
  [LOAD_FORMULA](state: FormulaState) {
    state.toEditFormula = {
      ...state.toEditFormula,
      loading: true,
      error: null,
    };
  },
  [LOAD_FORMULA_SUCCESS](state: FormulaState, toEditFormula: Formula) {
    state.toEditFormula = {
      data: { ...toEditFormula },
      loading: false,
      error: null,
    };
  },
  [LOAD_FORMULA_FAILURE](state: FormulaState, error: string) {
    state.toEditFormula = {
      ...state.toEditFormula,
      loading: false,
      error: error,
    };
  },
  [INIT_STORE_FORMULA_FAILURE](state: FormulaState) {
    state.toEditFormula = {
      data: {} as Formula,
      error: null,
      loading: false,
    };
  },

  // FORMULA VARIABLES
  [LOAD_FORMULA_VARIABLES](state: FormulaState) {
    state.variables = {
      ...state.variables,
      loading: true,
      error: null,
    };
  },
  [LOAD_FORMULA_VARIABLES_SUCCESS](state: FormulaState, data: any) {
    state.variables = {
      data: data.variables,
      count: data.count,
      loading: false,
      error: null,
    };
  },
  [LOAD_FORMULA_VARIABLES_FAILURE](state: FormulaState, error: string) {
    state.variables = { ...state.variables, loading: false, error: error };
  },

  // CHECK FORMULA
  [CHECK_FORMULA](state: FormulaState) {
    state.currentFormula = {
      ...state.currentFormula,
      loading: true,
      error: null,
    };
  },
  [CHECK_FORMULA_SUCCESS](state: FormulaState, params: any) {
    state.currentFormula = {
      data: params.data,
      valid: true,
      result: params.result,
      loading: false,
      error: null,
    };
  },
  [CHECK_FORMULA_FAILURE](state: FormulaState, error: string) {
    state.currentFormula = {
      ...state.currentFormula,
      valid: false,
      result: null,
      loading: false,
      error: error,
    };
  },

  // SAVE_FORMULA
  [SAVE_FORMULA](state: FormulaState) {
    state.formula = {
      ...state.formula,
      loading: true,
      error: null,
    };
  },
  [SAVE_FORMULA_SUCCESS](state: FormulaState, newFormula: Formula) {
    state.formula = {
      data: { ...newFormula },
      loading: false,
      error: null,
    };
  },
  [SAVE_FORMULA_FAILURE](state: FormulaState, error: string) {
    state.formula = {
      ...state.formula,
      loading: false,
      error: error,
    };
  },

  // RESET FORMULA
  [RESET_FORMULA](state: FormulaState) {
    state.currentFormula = {
      data: {},
      valid: false,
      result: null,
      loading: false,
      error: null,
    };
  },

  // RESET NEW FORMULA
  [RESET_NEW_FORMULA](state: FormulaState) {
    state.formula = {
      data: {} as Formula,
      loading: false,
      error: null,
    };
  },

  // RESET_TO_EDIT_FORMULA
  [RESET_TO_EDIT_FORMULA](state: FormulaState) {
    state.toEditFormula = {
      data: {} as Formula,
      loading: false,
      error: null,
    };
  },
};
